import { createFileRoute } from '@tanstack/react-router'
import { SchedulePage } from '@/features/reception/pages/schedule-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/schedule')({ component: Screen })
function Screen() {
  const { workspaceSlug } = Route.useParams()
  return <SchedulePage slug={workspaceSlug} />
}
